import {
	CUSTOM_INTEGRATION_URL,
	CUSTOM_INTEGRATION_JSON_URL,
} from 'utils/AllURLs'

export default (id, type) =>
	type === 'json'
		? `
import requests
import json

url = "${CUSTOM_INTEGRATION_JSON_URL}/${id}"

payload = json.dumps({
  "first_name": "Tolleen",
  "last_name": "Integration",
  "phone": "6095554466",
  "ABrandNewAttributeNeverBeforeSeen": "Yes",
  "color": "orange",
  "favorite_dinner": "The Bacon Double Cheeseburger",
  "where_are_you": "at a store",
  "favorite_letter": "G"
})
headers = {
  'Content-Type': 'application/json'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)

`
		: `
import requests

url = "${CUSTOM_INTEGRATION_URL}/${id}"

payload='first_name=Tolleen&last_name=Integration&phone=6095554466&ABrandNewAttributeNeverBeforeSeen=Yes&color=orange&favorite_dinner=The%20Bacon%20Double%20Cheeseburger&where_are_you=at%20a%20store&favorite_letter=G'
headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)
`
